import React, { useState, useEffect } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchJob } from "@workspace/job/src/store/actions";
import classnames from "classnames";
import {
  ClientJobTab,
  ClientCandidatesTab,
} from "@workspace/portfolio/src/components";
import "./ClientJobView.scss";
import { DateHelper } from "@workspace/common";

function ClientJobView() {
  document.title = "Client Job View | Pulse";
  const dispatch = useDispatch();

  const { id } = useParams();

  const jobData = useSelector((state) => state?.JobReducer?.job);

  const [activeTab, setActiveTab] = useState("1");
  const [job, setJob] = useState(null);

  useEffect(() => {
    dispatch(fetchJob(id));
  }, [id]);

  useEffect(() => {
    if (jobData) {
      setJob(jobData?.jobSubmissionData);
    }
  }, [jobData]);


  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="page-content bg-white">
      <div className="overview-header sticky-header">
        <div className="d-flex justify-content-between flex-wrap w-100 mb-2 px-2">
          <div className="d-flex flex-column gap-1">
            <span className="text-muted">Job ID</span>
            <span className="fw-semibold" style={{ color: "#0A56AE" }}>
              {job?.jobId}
            </span>
          </div>
          <div className="d-flex flex-column gap-1">
            <span className="text-muted">Job Title</span>
            <span className="fw-semibold" style={{ color: "#0A56AE" }}>
              {job?.jobTitle}
            </span>
          </div>
          <div className="d-flex flex-column gap-1">
            <span className="text-muted">Recruiter</span>
            <span className="fw-semibold" style={{ color: "#0A56AE" }}>
              {job?.accountContact}
            </span>
          </div>
          <div className="d-flex flex-column gap-1">
            <span className="text-muted">Created On</span>
            <span className="fw-semibold" style={{ color: "#0A56AE" }}>
              {DateHelper.formatDateStandard2(jobData?.createdAt)}
            </span>
          </div>
          <div className="d-flex flex-column gap-1">
            <span className="text-muted"># of Candidates Applied</span>
            <span className="fw-semibold" style={{ color: "#0A56AE" }}>
              10
            </span>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <Row>
          <Col>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: activeTab == 1 })}
                  onClick={() => toggle("1")}
                >
                  Job Description
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: activeTab == 2 })}
                  onClick={() => toggle("2")}
                >
                  Candidates
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Row>
                  <Col>
                    <ClientJobTab jobData={jobData} job={job} />
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <Row>
                  <Col>
                    <ClientCandidatesTab id={id} />
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default ClientJobView;
